import { render, staticRenderFns } from "./HomeFoot.vue?vue&type=template&id=35a3f6e6&scoped=true&"
import script from "./HomeFoot.vue?vue&type=script&lang=js&"
export * from "./HomeFoot.vue?vue&type=script&lang=js&"
import style0 from "./HomeFoot.vue?vue&type=style&index=0&id=35a3f6e6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3f6e6",
  null
  
)

export default component.exports